import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ICONS } from '../../../constants/constants';
import { DateTimeService } from '../../../services/date-time.service';

@Component({
  selector: 'app-time-input',
  templateUrl: './time-input.component.html',
  styleUrls: ['./time-input.component.scss'],
})
export class TimeInputComponent {
  protected readonly ICONS = ICONS;

  @Input() public fc: UntypedFormControl;
  @Input() public placeholder: string = '';

  onBlur(): void {
    this.fc.setValue(DateTimeService.formatTime(this.fc.value ?? ''), {
      emitEvent: false,
    });
  }
}
